import { useSelector } from 'react-redux';

// Components
import { IconArrowsLeftRight } from '@u21/tabler-icons';

import { U21Chip } from 'app/shared/u21-ui/components';

// Models
import { selectHasReadEventsPermission } from 'app/modules/session/selectors';
import { useToggleTransactionSidebar } from 'app/modules/sidebar/hooks';

interface EventChipProps {
  eventID: number | string;
  externalID?: string;
}

export const EventChip = ({ eventID, externalID }: EventChipProps) => {
  const hasReadEventsPermission = useSelector(selectHasReadEventsPermission);
  const toggleTransactionSidebar = useToggleTransactionSidebar();

  const displayLabel = externalID || `Event #${eventID}`;

  return (
    <U21Chip
      icon={<IconArrowsLeftRight />}
      onClick={
        hasReadEventsPermission
          ? (e) => {
              e.stopPropagation();
              toggleTransactionSidebar(eventID, e);
            }
          : undefined
      }
    >
      {displayLabel}
    </U21Chip>
  );
};
